/* eslint-disable no-unused-vars */
import { create } from 'zustand'

interface PermissionState {
  role: string | null
  permissions: string[]
  setPermissions: (role: string, permissions: string[]) => void
}

export const usePermissionStore = create<PermissionState>((set, get) => ({
  role: null,
  permissions: [],
  setPermissions: (role, permissions) => set({ role, permissions }),
}))
